import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { useDropzone } from "react-dropzone"
import { uploadImage } from "@/store/features/genericSlice"
import ImageUploadView from "@/components/RegisterOfflineProduct/v1/ImageUpload/ImageUploadView.jsx"
import styles from "@/components/RegisterOfflineProduct/v1/ImageUpload/index.module.scss"

const ImageUpload = ({
  data,
  staticText = {},
  isOmnichannel = false,
  isDisabled = false,
  clearImage = false,
  setClearImage = ()=>{},
  setUploadImageLoading = () => { },
  authorData = {},
  ...props
}) => {
  const dispatch = useDispatch()
  const [uploadedImage, setUploadedImage] = useState([])
  const [infoArr, setInfoArr] = useState([])
  const [imagePath, setImagePath] = useState([])
  const [error, setError] = useState("")
  const [fileCount, setFileCount] = useState(5)
  const [path, setPath] = useState([])
  const [uploaderStatus, setUploaderStatus] = useState(false)
  const [clear, setClear] = useState(false)
  const [status, setStatus] = useState("")

  const { getRootProps, getInputProps } = useDropzone({
    accept: !isOmnichannel
      ? "image/png, image/jpg, image/jpeg, application/pdf"
      : "image/png, image/jpg, image/jpeg, application/pdf, image/gif",
    maxFiles: fileCount,
    maxSize: 5242880 /*5MB in bytes(binary format) */,
    multiple: !isOmnichannel ? true : false,
    disabled: !isOmnichannel ? uploaderStatus : isDisabled,
    onFileDialogCancel: () => {
      if (uploadedImage?.length === 0 && !isOmnichannel) {
        setError(staticText.provideImageError)
      }
    },
    onDrop: acceptedFiles => {
      if (uploadedImage.length < 5) {
        let list = []
        setUploadImageLoading(true)
        acceptedFiles.map(files => {
          dispatch(
            uploadImage({ uplaodData: files, isReturn: false, isOmnichannel, authorData })
          )
            .unwrap()
            .then(res => {
              setUploadImageLoading(false)
              list.push(res.path)
              setPath([...path, ...list])
            })
            .catch(err => {
              console.error("Failed to upload files", err)
              setUploadImageLoading(false)
            })
        })
        let imageFiles = acceptedFiles.map(files =>
          Object.assign(files, { preview: URL.createObjectURL(files) })
        )
        setUploadedImage([...uploadedImage, ...imageFiles])
        setFileCount(fileCount - acceptedFiles.length)
        setError("")
      } else {
        setUploaderStatus(true)
        setUploadImageLoading(false)
        setError(staticText.uploadLimitError)
      }
    },
    onDropRejected: fileRejectionItems => {
      if (fileRejectionItems[0].errors[0].code === "file-too-large") {
        setError(staticText.uploadFileSizeError)
      } else if (fileRejectionItems[0].errors[0].code === "file-invalid-type") {
        setError(staticText.uploadFileTypeError)
      } else if (fileRejectionItems[0].errors[0].code === "too-many-files") {
        setError(staticText.uploadLimitError)
      }
      setUploadImageLoading(false)
    },
  })

  useEffect(() => {
    if (data.customerImage.length > 0) {
      let path = data.customerImage.map(img => {
        return img.url
      })
      setImagePath(path)
      setInfoArr(data.customerImage)
    }
    if (data.uploadedImage.length > 0) {
      setUploadedImage(data.uploadedImage)
      setFileCount(fileCount - data.uploadedImage.length)
    }
    if (data?.productImages?.length > 0) {
      setPath(data.productImages)
    }
  }, [])

  useEffect(() => {
    if (infoArr.length > 0 && uploadedImage.length > 0) {
      setInfoArr(
        uploadedImage.map(data => {
          return { url: data.url, comment: data.comment }
        })
      )
    }
    props.handleData({ ...data, uploadedImage: uploadedImage })
  }, [uploadedImage])
  useEffect(() => {
    if (clearImage) {
      setUploadedImage([])
      setError("")
      setClearImage(false)
    }
  }, [clearImage])
  useEffect(() => {
    props.handleData({ ...data, customerImage: infoArr })
  }, [infoArr])

  useEffect(() => {
    props.handleData({ ...data, productImages: path })
  }, [path])

  useEffect(() => {
    if (path.length > 0) {
      let pathList = []
      uploadedImage.forEach((img, index) => {
        pathList[index] = path.find(value => {
          let name = value.split("/")
          return name[4] === img.name
        })
      })
      setImagePath(pathList)
      setClear(false)
    }
  }, [path])

  useEffect(() => {
    if (uploadedImage.length > 0) {
      let uploads = uploadedImage.map((data, index) => {
        let path = imagePath.find((path, i) => i === index)
        return Object.assign(data, { url: path })
      })
      setUploadedImage(uploads)
      setInfoArr(
        uploadedImage.map(data => {
          return { url: data.url, comment: data.comment }
        })
      )
    }
    if (imagePath.length > 0) setStatus("")
  }, [imagePath])

  useEffect(() => {
    if (clear) {
      setInfoArr(
        uploadedImage.map(data => {
          return { url: data.url, comment: data.comment }
        })
      )
      setStatus(staticText.ariaLabel.imageRemove)
    }
  }, [clear])

  const getAddMorePhotosAnalytics = () => {
    return JSON.stringify({
      clickInternalLinks: "true",
      eventAction:
        "my account:register offline kohler products:product information:add more photos",
      eventName:
        "my account:register offline kohler products:product information:add more photos",
      eventType: "informative",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: "add more photos",
      internalLinkPosition: "register offline kohler products",
      internalLinkType: "my account:navigation",
      internalLinkZoneName:
        "my account:register offline kohler products:product information",
      internalLinkURL: "n/a",
    })
  }

  return (
    <div className={`${styles.imageUploadWrapper}`}>
      <div className="image-upload-content">
        <section className="container">
          <div
            {...getRootProps({ className: "dropzone" })}
            id="image-dropzone-container"
          >
            <input id="kf-image-upload" {...getInputProps()} />
            {uploadedImage.length > 0 &&
              uploadedImage.map((file, index) => (
                <ImageUploadView
                  key={index}
                  index={index}
                  file={file}
                  data={data}
                  url={file?.url}
                  comment={file?.comment}
                  uploadedImage={uploadedImage}
                  setUploadedImage={setUploadedImage}
                  imagePath={imagePath}
                  setImagePath={setImagePath}
                  path={path}
                  setPath={setPath}
                  clearErrorMsg={setError}
                  fileCount={fileCount}
                  addCount={setFileCount}
                  handleUploader={setUploaderStatus}
                  setClear={setClear}
                  {...props}
                />
              ))}
            {uploadedImage?.length < 1 && (
              <div className="file-upload-container">
                <div className="drag-and-drop-title">
                  {staticText.drag} &amp; {staticText.drop}
                </div>
                <div className="or-text">{staticText.or}</div>
                <div
                  className={`upload-button ${
                    props.uploadButtonAnalytics ? "gbh-data-layer" : ""
                  } ${isOmnichannel && isDisabled ? "disable" : ""}`}
                  data-gbh-data-layer={props.uploadButtonAnalytics}
                >
                  <span className={`upload-button-text`}>
                    {staticText.uploadPhoto}
                  </span>
                </div>
              </div>
            )}

            {!isOmnichannel &&
              uploadedImage?.length >= 1 &&
              uploadedImage.length < 5 && (
                <div
                  className="file-upload-container"
                  onClick={e => e.stopPropagation()}
                >
                  <div
                    className="upload-button  gbh-data-layer"
                    data-gbh-data-layer={getAddMorePhotosAnalytics()}
                    tabIndex="0"
                    role="button"
                    {...getRootProps()}
                  >
                    <span className="upload-button-text">
                      {staticText.addPhoto}
                    </span>
                  </div>
                </div>
              )}
            <div
              role="region"
              label="status"
              aria-live="polite"
              className="aria-messages"
            >
              {status}
            </div>
            {error && (
              <span className="file-upload-container__error-msg">{error}</span>
            )}
          </div>
        </section>
      </div>
    </div>
  )
}

export default ImageUpload
